var _circle, _circle2, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 12,
    viewBox: "0 0 103 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.3016,
    cy: 5.7,
    r: 5.7,
    fill: "#01AB6C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.5008,
    cy: 5.7,
    r: 5.7,
    fill: "#323232"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5008,
    cy: 5.7,
    r: 5.7,
    fill: "#01AB6C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.7,
    cy: 5.7,
    r: 5.7,
    fill: "#01AB6C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.7,
    cy: 5.7,
    r: 5.7,
    fill: "#01AB6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/Step-4.a72d9b6b5d510503c90045fcdefc6d4e.svg";
export { ForwardRef as ReactComponent };